//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Pageview from '@/mixins/Pageview'
import SeoMethods from '@/mixins/SeoMethods'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'BlogPostPage',
  mixins: [SeoMethods, Pageview],
  layout: 'blank',
  auth: false,
  data () {
    return {
      post: null,
      imageOptions: {
        resize: {
          width: 1600,
          height: 500
        }
      }
    }
  },
  async fetch () {
    const post = await this.$axios.get('/posts/' + this.$route.params.slug)
    this.post = post.data.data
  },
  head () {
    const { post } = this
    return this.buildTags(post?.title, post?.text, post?.image)
  },
  computed: {
    dateCreated () {
      return this.$moment(this.post.createdAt).format('DD.MM.YYYY')
    }
  }
}
